/*
by zhang.qiang 2017/03/08
 */
"use strict";
angular.module('manageSysManageNewSysOperationModalModule', [])
    .controller('manageSysManageNewSysOperationModalCtrl', ['$scope', '$validation', 'editPictureService', '$modalInstance', 'Upload', 'Params', 'trsHttpService', 'modalDialog', function($scope, $validation, editPictureService, $modalInstance, Upload, Params, trsHttpService, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {

            $scope.status = angular.copy(Params);
            $scope.status.uploadImageSrc = Params.hasOwnProperty('LOGOPIC') ? Params.LOGOPIC : '';
            $scope.status.InUse = Params.hasOwnProperty('INUSE') ? Params.INUSE : '0';
            $scope.title = Params.OPERATIONALCONFIGID == "0" ? "新建" : "修改";
            $scope.status.isEdit = false;

            $scope.data = {
                allSystems: [],
                systemSelected: [],
                queryStatus: [{ name: "启用", value: "1" }, { name: "禁用", value: "0" }], //是否是核心稿库
                isShowBtn: Params.hasOwnProperty('LOGOPIC') ? false : true,
                editIcon: false,
                replaceIcon: Params.hasOwnProperty('LOGOPIC') ? true : false
            }

            angular.forEach(Params.allSystems, function(data, index, array) {
                $scope.data.allSystems.push({
                    name: data.CONFIGNAME,
                    value: data.CONFIGORDER
                });
            });
            $scope.data.allSystems.unshift({
                name: "最前面",
                value: 0
            });

            if (Params.OPERATIONALCONFIGID == "0") {
                $scope.data.systemSelected = angular.copy($scope.data.allSystems[0]);
            } else {
                angular.forEach($scope.data.allSystems, function(data, index, array) {
                    if (data.value == $scope.status.CONFIGORDER) {
                        $scope.data.allSystems.splice(index, 1);
                        $scope.data.systemSelected = angular.copy($scope.data.allSystems[index-1]);
                    }
                });
            }
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {

        }

        $scope.singleSelect = function(item) {
            $scope.status.InUse = item.value;
        };

        /**
         * [cancel 取消]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm 确定]
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.newSysOperationModal.$pending = {};
            $validation.validate($scope.newSysOperationModal).success(function() {
                var params = {
                    serviceid: "mlf_operationalconfig",
                    methodname: "saveConfig",
                    ConfigId: $scope.status.OPERATIONALCONFIGID,
                    ConfigName: $scope.status.CONFIGNAME,
                    ConfigValue: $scope.status.CONFIGVALUE,
                    Description: $scope.status.DESCRIPTION,
                    InUse: $scope.status.InUse,
                    ConfigOrder: $scope.data.systemSelected.value?$scope.data.systemSelected.value:1
                }
                if ($scope.status.isEdit) {
                    params.LogoPicInfo = [{
                        "appFile": $scope.status.selectImage,
                        "appDesc": $scope.status.selectImage,
                        "PERPICURL": $scope.status.uploadImageSrc
                    }]
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $modalInstance.close("success");
                }, function(data) {
                    $modalInstance.close(data);
                });
            });
        };

        /**
         * [selectFile description] 上传本地图片
         * @param  {[array]} $files    [description] file数组
         * @param  {[object]} $file     [description] 
         * @param  {[array]} $newFiles [description] 本次上传的file数组
         * @return {[type]}           [description]
         */
        $scope.selectFile = function($files, $file, $newFiles) {
            var file = {};
            $scope.loadingPromise = Upload.upload({
                url: "/wcm/openapi/uploadImage",
                data: {
                    file: $newFiles[0]
                },
            }).then(function(resp) {
                if (resp.data.success) {
                    editPicture(resp.data.imgSrc, resp.data.imgName);
                } else {
                    file.error = resp.data.error;
                }
            }, function(resp) {
                if (resp.status == '413') {
                    file.error = '文件太大，不得大于30MB!';
                } else {
                    file.error = '未知错误!';
                }
            }, function(evt) {
                file.FILEINFO = "上传中";
            });
        }

        /**
         * [editPicture description] 编辑图片
         * @return {[type]} [description]
         */
        function editPicture(imgSrc, imgName) {
            editPictureService.editPicture({
                PERPICURL: imgSrc,
                APPFILE: imgName
            }, "", function(data) {
                $scope.data.isShowBtn = false;
                $scope.status.isEdit = true;
                $scope.status.uploadImageSrc = data.imgSrc;
                $scope.status.selectImage = data.imgName;
            });
        };
    }]);